/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DownloadFromCloudIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Download From Cloud',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M31 11.3a6.461 6.461 0 0 0-2.151-.118 8.345 8.345 0 0 0 0-4.407 8.024 8.024 0 0 0-5.71-5.648 8.162 8.162 0 0 0-10.215 6.821 6.97 6.97 0 0 0-3.361-.055 6.849 6.849 0 0 0-5.124 5.212 6.972 6.972 0 0 0 .078 3.237 3.862 3.862 0 0 0-4.464 4.449A4 4 0 0 0 4.064 24H16v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9h9.572A6.429 6.429 0 0 0 31 11.3Z"
    />
    <path
      d="M16 28h-4.3a.7.7 0 0 0-.7.7.685.685 0 0 0 .207.49l6.468 6.145a.5.5 0 0 0 .65 0l6.469-6.135a.688.688 0 0 0 .206-.49.7.7 0 0 0-.7-.7H20V24h-4Z"
    />
  </svg>`;
};
